import { CSSProperties, createContext, useContext } from 'react';

export interface FormUIContextValue {
  /**
   * @default "100px"
   */
  labelWidth?: string;
  labelStyle?: CSSProperties;
  /**
   * @default "vertical"
   */
  direction?: 'vertical' | 'horizontal';
}

export const FormUIContext = createContext<FormUIContextValue>({});

export const useFormUIContext = () => useContext(FormUIContext);
